import React from 'react';
import { ITranslateProps, translate } from '../../mixins/translate';
import { fetchGet } from '../../store/fetch';
import { formatBytes } from '../../utils/formatBytes';
import { NullableFormattedDate } from '../utils/NullableFormattedDate';

export interface ICompanyUsage {
    id: string;
    createdOn: Date;
    objectsCount: number;
    storageUsed: number;
}

export interface ICompanyUsagesListState {
    items: ICompanyUsage[];
}

class CompanyUsagesListComponent extends React.Component<ITranslateProps, ICompanyUsagesListState> {
    constructor(props: ITranslateProps) {
        super(props);

        this.state = {
            items: [],
        };
    }

    public override async componentDidMount() {
        await this.load();
    }

    public override render() {
        return (
            <div className="panel-body ph20">
                <table className="table admin-form theme-warning tc-checkbox-1 fs13">
                    <thead>
                        <tr className="bg-light">
                            <th className="">{this.props.t('common.date')}</th>
                            <th className="">{this.props.t('dashboard.storageUsed')}</th>
                            <th className="">{this.props.t('common.objects')} </th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.items.map((item) => (
                            <tr key={item.id}>
                                <td className="" style={{ whiteSpace: 'nowrap' }}>
                                    <NullableFormattedDate value={item.createdOn} />{' '}
                                </td>
                                <td className="" style={{ whiteSpace: 'nowrap' }}>
                                    {formatBytes(item.storageUsed)}
                                </td>
                                <td className="">{item.objectsCount}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className={this.state.items.length > 0 ? 'hidden' : ''}>
                    <div className="mt40 ml10">
                        {' '}
                        <h5>{this.props.t('dashboard.noData')} </h5>
                    </div>
                </div>
            </div>
        );
    }

    private async load() {
        const url = '/api/companyUsages';
        const result = await fetchGet(url, {}, [], [403]);
        if (result.json) {
            this.setState({ items: result.json.items });
        }
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const CompanyUsagesList = translate()(CompanyUsagesListComponent);
export { CompanyUsagesList };
